import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Panel, LoadingState, ErrorState } from "@/components/common";
import { TickerTable } from "@/pages/CryptoMarkets";
import { Radar, Info } from "lucide-react";

export default function Scanner() {
  const nav = useNavigate();
  const q = useQuery({ queryKey: ["crypto-scanner"], refetchInterval: 20000,
    queryFn: async () => (await api.get("/market/crypto/scanner")).data });
  if (q.isLoading) return <LoadingState label="Scanning markets..." />;
  if (q.isError) return <ErrorState label="Scanner data unavailable" onRetry={q.refetch} />;
  return (
    <div>
      <PageHeader title="Universal Market Scanner" subtitle="Ranked by 24h move · Binance public data" icon={Radar} demo={false} testId="scanner-header" />
      <div data-testid="scanner-gtf-notice" className="mb-4 flex items-start gap-2 rounded-lg border border-amber-500/30 bg-amber-500/5 px-4 py-3">
        <Info className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
        <span className="text-xs text-amber-200">{q.data.label} Stock scanning starts once Sharekhan data is connected.</span>
      </div>
      <Panel title="Crypto movers" testId="scanner-panel">
        <TickerTable testId="scanner-table" items={q.data.items} onSelect={() => nav("/app/crypto")} />
      </Panel>
    </div>
  );
}
